/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TeacherGroupInfo } from './teacherGroupInfo';

/**
 * Serializer for invitation detail (auto-generated from dataclass).
 */
export interface InvitationDetail { 
    invitationId: string;
    email: string;
    firstName: string;
    lastName: string;
    teacherGroups: Array<TeacherGroupInfo>;
    createdAt: string;
    lastSentAt: string;
    expirationDate: string;
    resentCount: number;
    isExpired: boolean;
}